import { Button } from '@ui-kit/Button';
import classNames from 'classnames';
import { PropsButtonRecord } from './PropsButtonRecord';
import IconRecord from './record-icon.svg';
import { MyLink } from '@ui-kit/Link';
import { TargetClickRecordWidget } from '@app/features/callKolesoWidget';

import styles from './ButtonRecord.module.scss';

export const ButtonRecord = ({ value, className }: PropsButtonRecord): JSX.Element => {
  return (
    <TargetClickRecordWidget>
      <Button className={classNames(styles.Button, className)} themes="red">
        <IconRecord /> {value}
      </Button>
    </TargetClickRecordWidget>
  );
};

ButtonRecord.BtnLink = function BtnLink({ value, href, className, ...other }: PropsButtonRecord) {
  return (
    <MyLink href={href || '/rec/?widgetOpened'} {...other}>
      <Button className={classNames(styles.Button, className)} themes="red">
        <IconRecord /> {value}
      </Button>
    </MyLink>
  );
};
